import { render, staticRenderFns } from "./CardRating.vue?vue&type=template&id=30ff971f"
import script from "./CardRating.vue?vue&type=script&lang=js"
export * from "./CardRating.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports